import logger from 'src/logger';
import LineItem from './LineItem';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { connect } from 'react-redux';
import { fetchPrismicProduct } from '../../../../store/thunks/prismic/product';
import { getPrismicProduct, getPrismicProductByLocale } from '../../../../store/selectors/prismic/product';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import pick from 'lodash/pick';
import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import buildProductUrl from '../../../utils/buildProductUrl';

import {
  getFormatImage,
  mergeAddons,
  getTitle,
  getType,
  getCustomisationString,
  getExpandedCustomisation,
  buildEditUrl,
  buildCustomisationsFromItem,
} from './helpers';
import {
  trackRemoved,
  trackEditAddons,
  trackEditItem,
  trackAddAddons,
} from '../../../../analytics/category/cart';

import orderBy from 'lodash/orderBy';
import withCountry from '../../../hocs/withCountry';
import { getAddons } from 'src/common/facades/website/product/addons';
import withProductKey from '../../../hocs/withProductKey';

const enhance = compose(
  withCountry,
  withState('isLoading', 'setIsLoading', true),
  withState('giftwrapCta', 'updateGiftwrapCta', null),
  withState('extrasCta', 'updateExtraCta', null),
  connect(
    (state, props) => ({
      fallbackProduct: pick(
        getPrismicProductByLocale(
          state,
          props.item.format.product.id,
          props.country.localeCode,
        ),
        ['response', 'productInformation', 'cart', 'form'],
      ),
      product: pick(
        getPrismicProductByLocale(
          state,
          props.item.format.product.id,
          props.item.customisations.locale,
        ),
        ['response', 'productInformation', 'cart', 'form'],
      ),
      prismicProductLangs: getPrismicProduct(
        state,
        props.item.format.product.id
      ),
    }),
    null
  ),
  connect(
    null,
    (dispatch, props) => ({
      getPrismicProduct: (sku, locale) =>
        dispatch(fetchPrismicProduct(sku, locale, props)),
    }),
  ),
  withHandlers({
    onRemove: props => () => {
      try {
        trackRemoved(props.item.format.product.id);
      } catch (error) {
        logger.error(error);
      }
      return props.handleRemove(props.item.id);
    },
    onEditItem: props => () => trackEditItem(props.item.format.product.id),
    onEditAddons: props => () => trackEditAddons(props.item.format.product.id),
    onAddAddons: props => () => trackAddAddons(props.item.format.product.id),
  }),
  withProps(props => ({
    productId: props.item.format.product.id
  })),
  withProductKey,
  lifecycle({
    componentDidMount() {
      const props = this.props;
      const customisations = omitBy(props.item.customisations, isNil);
      const locale = customisations.locale;
      const countryLocale = props.country.localeCode;
      const countryPrefix = props.country.prefix;
      Promise.all([
        props.getPrismicProduct(props.productId, locale),
        props.getPrismicProduct(props.productId, countryLocale),
        getAddons(props.productId, {
          ...customisations,
          format_identifier: get(props, 'item.format.id'),
          country: countryPrefix
        }),
      ])
        .then(([ product, fallbackProduct, addon ]) => {
          if (addon.giftwrapPageIdx !== null) {
            props.updateGiftwrapCta({
              edit: props.editGiftwrapCta,
              add: props.addGiftwrapCta,
              url: buildProductUrl(props, {
                type: 'options',
                itemId: props.item.id,
                queryParams: omitBy({
                  ...buildCustomisationsFromItem(props.item),
                  addonPage: addon.giftwrapPageIdx + 1
                }, isNil)
              }),
            });
          }
          if (addon.extrasPageIdx !== null) {
            props.updateExtraCta({
              edit: props.editExtrasCta,
              add: props.addExtrasCta,
              url: buildProductUrl(props, {
                type: 'options',
                itemId: props.item.id,
                queryParams: {
                  ...buildCustomisationsFromItem(props.item),
                  addonPage: addon.extrasPageIdx + 1
                }
              }),
            });
          }
          props.setIsLoading(false);
        })
        .catch((error) => {
          props.setIsLoading(false);
          logger.error(error);
        });
    },
  }),
  withProps(props => {
    const addons = orderBy(mergeAddons(props), ['type'], ['desc']);
    let expandedCustomisation = getExpandedCustomisation(props, addons);
    expandedCustomisation = props.isCustomisationsExpanded && expandedCustomisation.length > 0
      ? expandedCustomisation
      : [];
    return {
      onClickLink: {
        editItem: props.onEditItem,
        editAddons: props.onEditAddons,
        addAddons: props.onAddAddons,
      },
      image: getFormatImage(props).image,
      title: getTitle(props),
      customisationString: getCustomisationString(props),
      expandedCustomisation,
      itemCustomisation: props.item.customisations,
      displayFormat: getType(props),
      type: props.item.type,
      addons,
      price: props.item.price,
      savings: props.item.savings,
      editUrl: buildEditUrl(props),
    };
  }),
);

export default enhance(LineItem);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/LineItem/index.js